import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AssistantProvider } from "@/contexts/AssistantContext";
import LoginPage from "@/pages/LoginPage";
import LandingPage from "@/pages/LandingPage";
import QuickStartPage from "@/pages/QuickStartPage";
import EbookPage from "@/pages/EbookPage";
import PrintableChecklist from "@/pages/PrintableChecklist";
import AdminPage from "@/pages/AdminPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import ServicePage from "@/pages/ServicePage";
import FaqPage from "@/pages/FaqPage";
import ReferralsPage from "@/pages/ReferralsPage";
import ChecklistThanksPage from "@/pages/ChecklistThanksPage";
import InstallPrompt from "@/components/InstallPrompt";
import AssistantWidget from "@/components/assistant/AssistantWidget";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/quickstart" replace />;
  return children;
}

function LandingRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/quickstart" replace />;
  return <LandingPage />;
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AssistantProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              className: "border-2 border-[var(--c-border)] shadow-[3px_3px_0px_var(--c-shadow)] font-medium bg-[var(--c-surface)] text-[var(--c-text)]",
            }}
          />
          <Routes>
            <Route path="/" element={<LandingRoute />} />
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <LoginPage />
                </PublicRoute>
              }
            />
            <Route
              path="/quickstart"
              element={
                <ProtectedRoute>
                  <QuickStartPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ebook"
              element={
                <ProtectedRoute>
                  <EbookPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checklist"
              element={
                <ProtectedRoute>
                  <PrintableChecklist />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment-success"
              element={
                <ProtectedRoute>
                  <PaymentSuccessPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/services"
              element={
                <ProtectedRoute>
                  <ServicePage />
                </ProtectedRoute>
              }
            />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/checklist-thanks" element={<ChecklistThanksPage />} />
            <Route
              path="/referrals"
              element={
                <ProtectedRoute>
                  <ReferralsPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <InstallPrompt />
          <AssistantWidget />
          </AssistantProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
